import React, { useState } from 'react';
import SearchBar from '../common/Searchbar';
import closeIcon from '../../assets/images/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { setLPOpen } from '../../features/LP/LPOpenSlice';
import NoSubjectsAllocatedImage from '../../assets/images/NoSubjectsAllocatedScreen.svg';
import LPChapterList from './LPChapterList';

interface LPModalProps {
    chapters: any; //LPElement[];
    offset: number;
}

const LPModal: React.FC<LPModalProps> = ({ chapters, offset }) => {
    const [searchTerm, setSearchTerm] = useState<string>('');

    const dispatch = useDispatch();

    const handleLPClose = () => {
        dispatch(setLPOpen(false));
    };

    // Filter chapters based on the search term
    const filteredChapters = chapters?.filter((chapter: any) =>
        chapter?.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center w-full h-full z-40 ">
            <div className="modal bg-white pb-6 pt-4 px-12 rounded-xl shadow-lg flex flex-col font-sans lg:w-[60rem] h-[40rem]">
                <div className="flex justify-between">
                    <div className="flex items-center">
                        <h1 className="text-2xl text-black text-nowrap">
                            Lesson Plan
                        </h1>
                        <SearchBar
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </div>
                    <div>
                        <button
                            className="mt-2"
                            onClick={handleLPClose}
                            data-testid="lp-modal-close-button"
                        >
                            <img src={closeIcon} alt="close icon" />
                        </button>
                    </div>
                </div>
                <hr className="border-solid border-gray-300 mt-4 -mx-12" />

                <div className="overflow-y-scroll custom-scrollbar">
                    {filteredChapters?.length < 0 ? (
                        <div className="w-full h-full flex flex-col justify-center items-center gap-y-4 mt-2 p-4 font-sans">
                            <img
                                className="h-[22rem]"
                                src={NoSubjectsAllocatedImage}
                                alt="NoSubjectsAllocatedImage"
                            />
                            <h1 className="text-black text-2xl flex items-center justify-center ">
                                Lesson Plan Not Avaliable Currently
                            </h1>
                        </div>
                    ) : (
                        <LPChapterList
                            chapters={filteredChapters}
                            offset={offset}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LPModal;
